import { idb } from "../../db/index.ts";
import { g, helpers } from "../../util/index.ts";
import makeItWork, { type MakeItWorkFailureInfo } from "./makeItWork.ts";
import get from "./get.ts";
import { ValueChangeCalculator } from "../team/ValueChangeCalculator.ts";

/**
 * Make a trade work
 *
 * This should be called for a trade negotiation, as it will update the trade objectStore.
 *
 * @memberOf core.trade
 * @return {Promise.string} Resolves to a string containing a message to be dispalyed to the user, as if it came from the AI GM.
 */
const makeItWorkTrade = async () => {
	const tr = await get();
	const teams0 = tr.teams;
	const valueChangeCalculator = new ValueChangeCalculator();
	const failureInfo: MakeItWorkFailureInfo = {};
	const teams = await makeItWork(helpers.deepCopy(teams0), {
		holdUserConstant: false,
		valueChangeCalculator,
		failureInfo,
	});

	if (!teams) {
		return {
			changed: false,
			message: `${
				g.get("teamInfoCache")[teams0[1].tid]?.region
			} GM: "${
				failureInfo.reason === "salary"
					? "I like the pieces, but there's no way to make the money work under the salary rules."
					: "I can't afford to give up so much."
			}"`,
		};
	}

	// Store AI's proposed trade in database, if it's different
	let updated = false;

	for (const i of [0, 1] as const) {
		if (teams[i].tid !== teams0[i].tid) {
			updated = true;
			break;
		}

		if (teams[i].pids.toString() !== teams0[i].pids.toString()) {
			updated = true;
			break;
		}

		if (teams[i].dpids.toString() !== teams0[i].dpids.toString()) {
			updated = true;
			break;
		}
	}

	if (updated) {
		const tr2 = await get();
		tr2.teams = teams;
		await idb.cache.trade.put(tr2);
	}

	return {
		changed: updated,
		message: `${
			g.get("teamInfoCache")[teams[1].tid]?.region
		} GM: "How does this sound?"`,
	};
};

export default makeItWorkTrade;
